<template>
  <div class="parvandeh-role-select">
    <div class="parvandeh-role-select__sticky">
      <div class="parvandeh-role-select__top-box">
        <div class="parvandeh-role-select__label">{{ $lang.old_roles }}</div>
        <ParvandehRoleSelectLoading :loading="selectedRolesLoading">
          <template>
            <div class="parvandeh-role-select__slider">
              <div
                v-for="(role, roleIndex) in selectedRoles"
                :key="`a-${roleIndex}`"
                class="parvandeh-role-select__selected-item"
              >
                <span class="parvandeh-role-select__selected-item-text">
                  {{ role.caption }}
                </span>
                <span
                  class="parvandeh-role-select__selected-item-icon"
                  @click.stop="handleRemoveRole(role.code)"
                >
                  <mdicon name="close" size="16" />
                </span>
              </div>
            </div>
          </template>
        </ParvandehRoleSelectLoading>
      </div>
      <div class="padding-16">
        <div class="parvandeh-role-select__label">
          {{ $lang.select_new_role }}
        </div>
        <Input
          v-if="searchable"
          :label="$lang.search_title"
          :placeholder="$lang.search_title"
          :value="searchText"
          name="searchText"
          id="searchText"
          type="text"
          rightIcon="magnify"
          @input="handleInput"
        />
      </div>
    </div>
    <div class="parvandeh-role-select__roles">
      <RolesWrapper
        :loading="getRoleLoading"
        :rolesItems="rolesItems"
        :selectable="true"
      />
    </div>
  </div>
</template>

<script>
import ParvandehRoleSelectLoading from "./ParvandehRoleSelectLoading.vue";
import RolesWrapper from "@/components/re-design/roles/RolesWrapper.vue";
import { Input } from "@/components/re-design/forms";
import getRoleCodes from "./dependencies/roles/getRoleCodes";
import searchRoleCodes from "./dependencies/roles/searchRoleCodes";
import selectRoleCodes from "./dependencies/roles/selectRoleCodes";
import { provide, toRefs, watch } from "vue";
export default {
  components: { ParvandehRoleSelectLoading, RolesWrapper, Input },
  props: {
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props, { emit }) {
    // generate props data
    const { parvandehCode } = toRefs(props);

    // select role codes
    const {
      selectedRolesLoading,
      selectedRoles,
      handleRemoveRole,
      handleRoleSelect,
    } = selectRoleCodes(parvandehCode.value);

    // get role codes
    const { getRoleLoading, roles } = getRoleCodes();

    // generate search codes
    const { searchable, searchText, rolesItems, handleInput } =
      searchRoleCodes(roles);

    // handle provide data
    provide("handleRoleSelect", handleRoleSelect);

    // emit to parent selected roles
    watch(selectedRoles, (value) => emit("getSelectedRoles", value));

    return {
      searchable,
      searchText,
      selectedRolesLoading,
      selectedRoles,
      getRoleLoading,
      rolesItems,
      handleInput,
      handleRemoveRole,
      handleRoleSelect,
    };
  },
};
</script>
